module.exports = __webpack_public_path__ + "static/media/PP7-MacBook.6b9fe2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper7/PP7-MacBook.png
// module id = 304
// module chunks = 0